"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MessageCircle, Bell } from "lucide-react";

interface Notification {
  id: string;
  title: string;
  message: string;
  type: string;
  read: boolean;
  created_at: string;
}

interface ClientNotificationsProps {
  notifications: Notification[];
}

const ClientNotifications: React.FC<ClientNotificationsProps> = ({ notifications }) => {
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <Bell className="h-4 w-4" />
            <span>Notifications ({notifications.length})</span>
            {unreadCount > 0 && <Badge variant="destructive">{unreadCount} unread</Badge>}
          </CardTitle>
        </CardHeader>
        <CardContent>
          {notifications.length === 0 ? (
            <p className="text-muted-foreground">No notifications yet.</p>
          ) : (
            <div className="space-y-2">
              {notifications.map((notification) => (
                <div key={notification.id} className="p-3 border rounded">
                  <div className="font-medium">{notification.title}</div>
                  <p className="text-sm text-muted-foreground">{notification.message}</p>
                  <div className="flex items-center space-x-2 text-xs text-muted-foreground mt-1">
                    <MessageCircle className="h-3 w-3" />
                    <span>{new Date(notification.created_at).toLocaleDateString()}</span>
                    {!notification.read && <Badge variant="secondary">Unread</Badge>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ClientNotifications;